import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Typography, Row, Col, Card, Statistic } from 'antd'
import IMappingStatsPending from '../../interfaces/IMappingStatsPending'

type MappingStatsProps = {
  loading: boolean,
  mappingPending: IMappingStatsPending | null,

  loadMappingPending: () => void
}

export default class MappingStats extends Component<MappingStatsProps> {

  static defaultProps = {
    loading: false
  }

  componentDidMount() {
    const { loading, loadMappingPending } = this.props

    if (!loading) {
      loadMappingPending()
    }
  }

  renderAgeStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`age?filter_active=false`}>
        <Card loading={loading}>
          <Statistic
            title="Age"
            value={mappingPending?.mapping_age || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderBreedStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`breed?filter_active=false`}>
        <Card loading={loading}>
          <Statistic
            title="Breed"
            value={mappingPending?.mapping_breed || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderSexStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`sex?filter_active=false`}>
        <Card loading={loading}>
          <Statistic
            title="Sex"
            value={mappingPending?.mapping_sex || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderSizeStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`size?filter_active=false`}>
        <Card loading={loading}>
          <Statistic
            title="Size"
            value={mappingPending?.mapping_size || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderSpecieStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`specie?filter_active=false`}>
        <Card loading={loading}>
          <Statistic
            title="Species"
            value={mappingPending?.mapping_specie || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderCharacteristicStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`characteristic?filter_active=false`}>
        <Card loading={loading}>
          <Statistic
            title="Characteristic"
            value={mappingPending?.mapping_characteristic || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  render() {
    const { loading } = this.props

    return (
      <>
        <Typography.Title level={3}>Pending Mappings</Typography.Title>

        <Row gutter={8}>
          <Col xs={24} sm={4}>
            {this.renderAgeStats(loading)}
          </Col>

          <Col xs={24} sm={4}>
            {this.renderBreedStats(loading)}
          </Col>

          <Col xs={24} sm={4}>
            {this.renderSexStats(loading)}
          </Col>

          <Col xs={24} sm={4}>
            {this.renderSizeStats(loading)}
          </Col>

          <Col xs={24} sm={4}>
            {this.renderSpecieStats(loading)}
          </Col>

          <Col xs={24} sm={4}>
            {this.renderCharacteristicStats(loading)}
          </Col>
        </Row>
      </>
    )
  }
}
